import { getTransportTypeFromRegionId } from 'shared/utils/getTransportTypeFromRegionId';
import { type IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';
import { type TAdfoxBannerCompleteSizes } from 'shared/types/adfox';
import { type TransportProps } from 'shared/components/Transport/Transport';
import { type TTgbNativedescGeneralContext } from 'shared/types/bannerContext';

type TGetTgbNativedescGeneralCompleteContextOptions = {
  bannerEnrichments: IBannerEnrichments | null;
  context: TTgbNativedescGeneralContext;
  sizes: TAdfoxBannerCompleteSizes;
  regionId: number;
};

export type TGetTgbNativedescGeneralCompleteContextResult = {
  sizes: TAdfoxBannerCompleteSizes;
  url: string;
  image: string;
  logoImageUrl: string | undefined;
  title: string;
  description: string;
  address: string;
  builderName: string;
  annotation: string;
  button: string | undefined;
  label: string | undefined;
  transports: IterableArray<TransportProps>;
  mortgageWarning: string | undefined;
  mortgageTermsWarning: string | undefined;
};

export function getTgbNativedescGeneralCompleteContext({
  sizes,
  bannerEnrichments,
  context: {
    annotation,
    image,
    url,
    metroDistance,
    metroColor,
    metro,
    description,
    title,
    location,
    button,
    label,
    logoImageUrl,
    builderName,
    mortgageTermsWarning,
    mortgageWarning,
  },
  regionId,
}: TGetTgbNativedescGeneralCompleteContextOptions): TGetTgbNativedescGeneralCompleteContextResult {
  const completeContext: TGetTgbNativedescGeneralCompleteContextResult = {
    address: location,
    annotation,
    builderName,
    button,
    description,
    image,
    label,
    logoImageUrl,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
    title,
    transports: [],
    url,
  };

  if (metro) {
    const iconType = getTransportTypeFromRegionId(regionId);

    completeContext.transports.push({
      iconColor: metroColor,
      iconType,
      id: 1,
      name: metro,
      remoteness: metroDistance,
    });
  }

  if (bannerEnrichments) {
    Object.assign<
      TGetTgbNativedescGeneralCompleteContextResult,
      Partial<TGetTgbNativedescGeneralCompleteContextResult>
    >(completeContext, {
      address: bannerEnrichments.address,
      builderName: bannerEnrichments.publisher.name,
      logoImageUrl: bannerEnrichments.publisher.logo.url,
      // Если обогащение пришло без транспортов, сохраняем метро, собранное из контекста Adfox, а не затираем пустым массивом.
      transports: bannerEnrichments.transports.length > 0 ? bannerEnrichments.transports : completeContext.transports,
    });
  }

  return completeContext;
}
